class PostsList extends TableList {

  constructor(app, {calendarId: calendarId}, container, listRow, searchInputId = 'searchTable') {
    super(app, container, listRow, searchInputId)
    this.calendarId = calendarId;
    this.isRendering = true;
    app.observerManager = new ImageObserverManager(app, null, false);
    if (this.calendarId) {
      this.renderList(calendarId);
    }
  }

  static prepareRow(app, row, template) {
    let card = _.template(app.templates[template]);
    const postNetworks = _.template(app.templates['calender__partials-post-networks']);
    row.postNetworks = postNetworks(row);

    const postImage = _.template(app.templates['calender__partials-post-image']);
    row.postImage = postImage(row);

    const postFooter = _.template(app.templates['calender__partials-post-footer']);
    row.postFooter = postFooter(row);

    const postInfo = _.template(app.templates['calender__partials-post-info']);
    row.postInfo = postInfo(row);

    const $card = $(card(row));

    let $images = $('.svg-object, .post-image', $card);
    $images.each(function (index, image) {
      if ($(image).attr('data-src') !== '') {
        app.observerManager.observeIntersection(image);
      }
    });
    return $card;
  }


  loaderData = {
    approvedNotes: '',
    id: null,
    segments: 'custom',
    plan: 'free',
    image: '',
    domain: '',
    postNetworks: '',
    statusBadge: 'primary',
    status: this.staticPH,
    statusClass: '',
    showMaximize: true,
    cardFooter: true,
    swapButton: false,
    postDate: this.staticPH,
    text: this.staticPH,
    link: '',
    title: '',
    actionStatus: '',
    postImage: '',
    postFooter: '',
    postInfo: '',
    networks: []
  }

  processedLoaderData(overrideData = {}) {
    let data = this.loaderData;
    data.postImage = _.template(this.app.templates['calender__partials-post-image']);
    data.postImage = data.postImage(data);

    data.postFooter = _.template(this.app.templates['calender__partials-post-footer']);
    data.postFooter = data.postFooter(data);

    data.postInfo = _.template(this.app.templates['calender__partials-post-info']);
    data.postInfo = data.postInfo(data);

    data = {...data, ...overrideData};
    return data;
  }

  async renderListByPosts(data) {
    return this.renderList(null, data);
  }

  static storePosts(response) {
    const app = PreBuilt;
    response.posts = response.posts.map(function (post) {
      return PostFormatter.formattedData(app, post);
    })

    response.library = response.library.map(function (post) {
      return PostFormatter.formattedData(app, post);
    })

    window.calendarPosts = _.indexBy(response.posts, 'id');
    window.calendarLibrary = _.indexBy(response.library, 'id');
    window.campaignLirary = Utils.groupBy(response.posts, 'app_campaign_id');
    window.calendarLibraryByCampaignId = Utils.groupBy(response.library, 'app_campaign_id');

    return response;
  }

  static async updateCard(oldPost, newPost, remove = false, container = '.tab-content-calendar', article = false) {
    const app = PreBuilt;
    let template, rowTemplate;
    if (article === false) {
      template = 'calender__library-card';
      rowTemplate = 'calender__library-table-row';
    } else {
      template = 'feed__card-article';
      rowTemplate = 'feed__table-article';
    }

    const $container = $(container);

    if (remove === false) {
      let listManager = new PostsList(app, {calendarId: null}, null, template, null);
      let loaderCard = listManager.getLoaderRow(listManager.processedLoaderData(oldPost));
      let element = $(`.library-card-id-${oldPost.id}`, $container);
      element.replaceWith(loaderCard);

      listManager = new PostsList(app, {calendarId: null}, null, rowTemplate, null);
      loaderCard = listManager.getLoaderRow(listManager.processedLoaderData(oldPost));
      element = $(`.library-row-id-${oldPost.id}`, $container);
      element.replaceWith(loaderCard);
    } else {
      const libraryCard = $(`.library-card-id-${oldPost.id}`, $container);
      const libraryRow = $(`.library-row-id-${oldPost.id}`, $container);

      libraryCard.addClass('animated  m-progress');
      libraryRow.addClass('animated');
    }

    let response = await app.apis['calendar'].posts(app.calendarId);
    response = this.storePosts(response);

    if (remove === false) {
      let posts = response.posts.filter(obj => {
        return parseInt(obj.id) === parseInt(newPost.id);
      });

      let post = posts[0];

      // show card footer
      post.cardFooter = true;
      post.swapButton = false;
      post.showMaximize = true;
      // If article
      if (article !== false) {
        app.userTimeZone = app.apis['user'].get().timezone;
        if (!app.isEmpty(post.d)) {
          post.actionStatus = PostFormatter.actionStatus(post);
          post.d = PostFormatter.formatTime(post.d, app.userTimeZone);
          const postTime = PostFormatter.formatPostTime(post, app.userTimeZone);
          post = {...postTime, ...post}
        } else {
          post.postEditorTime = null;
        }
        post.post_id = post.id;
        post.id = post.article_id;

        // refresh articles
        const listManager = new ArticleList(app, $container, null, 'card', false, {}, false);
        listManager.storeArticles();
      }

      console.log(post);

      const libraryCard = $(`.library-card-id-${oldPost.id}`, $container);
      const card = this.prepareRow(app, post, template);
      libraryCard.replaceWith(card);

      const libraryRow = $(`.library-row-id-${oldPost.id}`, $container);
      const campaignViewRow = this.prepareRow(app, post, rowTemplate);
      libraryRow.replaceWith(campaignViewRow);

    } else {
      const libraryCard = $(`.library-card-id-${oldPost.id}`, $container);
      const libraryRow = $(`.library-row-id-${oldPost.id}`, $container);
      app.removeItem(libraryCard);
      app.removeItem(libraryRow, 'slideOutRight');
    }
  }

  static async deleteCard(postId, container = '.tab-content-calendar') {
    this.updateCard({id: postId}, {id: postId}, true, container)
  }

  async renderList(calendarId, response) {
    this.isRendering = true;
    const self = this;
    const app = this.app;
    const $listContainer = this.container.empty();

    this.showLoader(this.processedLoaderData());

    if (app.localStorage.getItem('build-calendar')) {
      const buildCalendar = app.localStorage.getItem('build-calendar');
      app.localStorage.removeItem('build-calendar');
      app.notify('success', 'Building posts for your calendar', true, {
        delay: 60000,
        allow_dismiss: false,
        type: 'dismissible alert-success top-50 text-center',
        placement: {from: 'top', align: 'center'}
      });

      const response = await app.apis['calendar'].build(calendarId);
      app.notifyEl.update({'message': response.message, progress: 100});
    }

    if (app.localStorage.getItem('build-campaign')) {
      const buildCampaign = JSON.parse(app.localStorage.getItem('build-campaign'));
      app.localStorage.removeItem('build-campaign');
      app.notify('success', 'Building posts for your campaign', true, {
        delay: 60000,
        allow_dismiss: false,
        type: 'dismissible alert-success top-50 text-center',
        placement: {from: 'top', align: 'center'}
      });

      try {
        response = await app.apis['campaign'].build(buildCampaign.id);
        app.notifyEl.update({'message': response.message, progress: 100});
      } catch (e) {
        console.log(e);
        const message = `${e.code} :: ${e.message.message}`;
        app.notifyEl.update({type: 'dismissible alert-danger', message: message, progress: 90});
      }

    }

    //  If app.calendar is empty
    if (this.app.isEmpty(app.calendar)) {
      await this.app.apis['calendar'].fetch();
    }

    if (this.calendarId) {
      this.response = await this.app.apis['calendar'].posts(calendarId);
    } else {
      this.response = response;
    }

    this.removeLoader();

    this.calendarEvents = [];
    this.response = PostsList.storePosts(this.response);

    _.each(this.response.posts, function (event, index) {
      if (typeof event.deleted == 'undefined') {
        // show card footer
        event.cardFooter = true;
        event.swapButton = false;
        event.showMaximize = true;
        const $post = PostsList.prepareRow(self.app, event, self.listRow);
        $post.appendTo($listContainer);

        let postTime = event.postTimeCalendar;
        const postImage = _.template(self.app.templates['calender__partials-post-image']);
        event.postImage = $(postImage(event))
        event.postImage = $(event.postImage).find('.image-wrapper.active').prop('innerHTML');

        self.calendarEvents.push({
          //backgroundColor: ['#da82f8', '#298DFF'].pop(),
          postId: event.id,
          title: event.postImage,
          // title: '<div class="post-item">' + event.postDayTime + ' ' + event.app_campaign_name + ' ' + event.text + '</div>',
          start: postTime,
          extendedProps: {
            toHtml: 'convert'
          }
        });
      }
    });

    self.campaignLirary = window.campaignLirary;
    app.initTooltip();

    this.isRendering = false;
    return response;
  }

  renderListByData(response) {
    this.isRendering = true;
    const self = this;
    const app = this.app;
    const $listContainer = this.container.empty();

    this.showLoader(this.processedLoaderData());

    this.removeLoader();

    self.calendarEvents = [];
    self.campaignLirary = Utils.groupBy(response.posts, 'app_campaign_id');
    this.response = response;

    _.each(response.posts, function (event, index) {
      if (typeof event.deleted == 'undefined') {
        // show card footer
        event.cardFooter = true;
        event.swapButton = false;
        event.showMaximize = true;
        const $post = PostsList.prepareRow(self.app, event, self.listRow);
        $post.appendTo($listContainer);

        let postTime = event.postTimeCalendar;
        const postImage = _.template(self.app.templates['calender__partials-post-image']);
        event.postImage = $(postImage(event))
        event.postImage = $(event.postImage).find('.image-wrapper.active').prop('innerHTML');

        self.calendarEvents.push({
          //backgroundColor: ['#da82f8', '#298DFF'].pop(),
          postId: event.id,
          title: event.postImage,
          // title: '<div class="post-item">' + event.postDayTime + ' ' + event.app_campaign_name + ' ' + event.text + '</div>',
          start: postTime,
          extendedProps: {
            toHtml: 'convert'
          }
        });
      }
    });

    app.initTooltip();

    this.isRendering = false;
    return response;
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async renderSwapLibrary(data) {
    const self = this;
    const $listContainer = this.container.empty();

    this.showLoader(this.processedLoaderData({'cardFooter': false}));

    await this.sleep(1000);
    $listContainer.empty();

    _.each(data, function (event, index) {
      if (typeof event.deleted == 'undefined') {
        // hide card footer
        event.cardFooter = false;
        event.swapButton = true;
        event.showMaximize = true;
        const $post = PostsList.prepareRow(self.app, event, self.listRow);
        $post.appendTo($listContainer);
      }
    });

    return data;
  }
}

const initCalendar = (app, calendarContainer = 'calendar-fc') => {
  const calendarEl = document.getElementById(calendarContainer);

  const curYear = moment().format('YYYY');
  const curMonth = moment().format('MM');
  const curDate = moment().format('DD');

  const calendar = new FullCalendar.Calendar(calendarEl, {
    initialView: 'dayGridMonth',
    initialDate: curYear + '-' + curMonth + curDate,
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    themeSystem: 'bootstrap',
    height: 'parent',
    events: [],
    eventContent: function (arg) {
      let $target = $(arg.event.title);
      if ($target.attr('data-type') === 'image') {
        $target.css({'background-image': 'url("' + $target.attr('data-src') + '")'});
      }

      let $object = app.createSvgObject($target);
      const image = $object[0].outerHTML;

      if (arg.event.extendedProps.toHtml) {
        return {html: image}
      }
    },

    eventClick: function (info) {
      const targetEvent = info.event;
      const postId = targetEvent.extendedProps.postId;
      aimi_post_editor.open(postId);
    }
  });

  setTimeout(function () {
    $('.fc-today-button').removeClass('btn-primary').addClass('btn-outline-light d-none');
    $('.fc-dayGridMonth-button,.fc-timeGridWeek-button,.fc-timeGridDay-button,.fc-listWeek-button').removeClass('btn-primary').addClass('btn-outline-light d-md-inline-block d-none');
    $('.fc-prev-button,.fc-next-button').addClass('btn-icon btn-flush-dark btn-rounded flush-soft-hover').find('.fa').addClass('icon');
    $('.fc-prev-button,.fc-next-button').addClass('btn-icon btn-flush-dark btn-rounded flush-soft-hover').find('.fa').addClass('icon');
    $('.fc-today-button').removeClass('btn-primary').addClass('btn-outline-light');
  }, 250);

  calendar.render();

  return calendar;
}

function postActions(e) {
  e.preventDefault();
  e.stopPropagation();

  const app = PreBuilt;

  const $this = $(this);
  const action = $this.data('post-action');

  let $postItem = $(e.target).closest('.post-item');
  let postId = $postItem.data('id');
  let post;
  let postType = 'Post';
  if (!app.isEmpty(postId)) {
    if (!app.isEmpty(window.calendarPosts[postId])) {
      post = app.clone(window.calendarPosts[postId]);
    }

    if (!app.isEmpty(window.calendarLibrary[postId])) {
      post = app.clone(window.calendarLibrary[postId]);
    }
  } else if ($postItem.hasClass('article-card')) {
    postType = 'Article';
    let $articleItem = $postItem.find('.article-item');
    post = app.clone(window.articlePosts[$articleItem.data('id')]);
    post.actionStatus = 'article';
  }

  if (action === 'swap') {
    const $modal = app.infoModal('Swap out this post for another', '', {
      id: 'swapModal',
      'dialogClass': 'modal-dialog-scrollable modal-full modal-swap-library'
    });
    app.swapData = {modal: $modal, post: post};
    const $modalBody = $('.modal-body', $modal);
    // app.messageLoader($modalBody).start();

    let template = _.template(app.templates['calender__swap-library']);
    const $template = $(template());
    $template.appendTo($modalBody);

    const $currentPostContainer = $template.find('[data-current-post]');
    const postData = app.clone(post);
    postData.swapButton = false;
    postData.cardFooter = false;
    postData.showMaximize = true;

    const $currentPost = PostsList.prepareRow(app, postData, 'calender__library-card');
    $currentPostContainer.append($currentPost);

    let $container = $template.find('[data-library-posts]');

    const $listManager = new PostsList(app, {calendarId: null}, $container, 'calender__library-card', false);

    if (postData.segments === 'article') {
      $container = $template.find('.lazy-loader-container');
      const articlesListManager = new ArticleList(app, $container, null, 'card', null, {
        excludePosts: true,
        swapButton: true,
        cardFooter: false
      });
      articlesListManager.onRenderList().then(function (articles) {

      })
    } else {
      const data = window.calendarLibraryByCampaignId[post.app_campaign_id];
      $listManager.renderSwapLibrary(data).then(function (response) {
      });

      const $manager = new ImageObserverManager(app, '.posts-grid-item', 'swap-card-width', $container);
      // To observe resizing for an element
      $manager.observeResize($container[0]);
    }
  }

  if (action === 'maximize') {
    const $modal = app.infoModal(postType, '', {id: 'maximizeModal', 'dialogClass': 'modal-full modal-maximize'});
    const $modalBody = $('.modal-body', $modal);

    let template = _.template(app.templates['calender__maximize']);
    const $template = $(template());
    $template.appendTo($modalBody);

    const $currentPostContainer = $template.find('[data-current-post]');
    const $currentPostInfoContainer = $template.find('[data-current-post-info]');

    const postData = app.clone(post);
    postData.showMaximize = false;
    postData.swapButton = false;
    postData.cardFooter = false;

    const $currentPost = PostsList.prepareRow(app, postData, 'calender__partials-post-image');
    $currentPostContainer.append($currentPost);

    const $currentPostInfo = PostsList.prepareRow(app, postData, 'calender__partials-post-info');
    $currentPostInfoContainer.append($currentPostInfo);
  }

  if (action === 'delete') {
    app.confirm('Delete Post', 'Are you sure to remove this post from calendar?').then(async function (response) {
      const $button = response.button;
      const confirm = response.confirm;
      const $modal = response.modal;

      // If the user confirms the deletion, proceed with the delete operation.
      if (confirm === true) {
        app.doButtonAction($button);
        const response = await app.apis['post'].delete(postId);
        app.hideModal($modal);
        app.doButtonReset($button);
        if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
          const campaignId = app.postActionsContext.split('-')[1];
          PostsList.deleteCard(postId, '.tab-content-campaign');
        } else if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('article')) {
          PostsList.deleteCard(postId, '.articles-container');
        } else {
          PostsList.deleteCard(postId);
        }
      }
    })
  }

  if (action === 'swap-out') {
    app.confirm('Swap Post', 'Are you sure to swap current post with this post?').then(async function (response) {
      const $button = response.button;
      const confirm = response.confirm;
      const $modal = response.modal;

      // If the user confirms the deletion, proceed with the delete operation.
      if (confirm === true) {
        const swapData = app.swapData;
        app.doButtonAction($button);
        let swapResponse;
        if (swapData.post.segments === 'article') {
          swapData.post.post_id = swapData.post.id;
          const articleId = $(e.target).closest('.article-item').data('id');
          swapResponse = await app.apis['article'].swap(app.calendarId, swapData.post.id, articleId);
          postId = swapData.post.id;
        } else {
          swapResponse = await app.apis['post'].swap(swapData.post.id, postId);
        }
        app.hideModal($modal);
        app.doButtonReset($button);
        app.hideModal(swapData.modal);
        if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
          const campaignId = app.postActionsContext.split('-')[1];
          PostsList.updateCard(swapData.post, {'id': postId}, false, '.tab-content-campaign');
        } else if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('article')) {
          PostsList.updateCard(swapData.post, {'id': postId}, false, '.articles-container', true);
        } else {
          PostsList.updateCard(swapData.post, {'id': postId});
        }
      }
    })
  }

  if (action === 'schedule') {
    app.doButtonAction($this);
    aimi_social_profiles.checkSocial().then(function (connectionOk) {
      if (connectionOk) {
        app.apis['post'].schedule([{id: postId, plan: post.plan}]).then(function () {
          app.doButtonReset($this);
          if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
            const campaignId = app.postActionsContext.split('-')[1];
            PostsList.updateCard(post, post, false, '.tab-content-campaign');
          } else if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('article')) {
            console.log(post);
            post.post_id = post.id;
            PostsList.updateCard(post, post, false, '.articles-container', true);
          } else {
            PostsList.updateCard(post, post);
          }
        });
      } else {
        app.doButtonReset($this);
      }

    });
  }

  if (action === 'retry') {
    const app = PreBuilt;
    const options = {
      modalDialogClass: 'modal-md modal-dialog-scrollable modal-dialog-centered  modal-build-more-posts',
      template: 'calender__retry-post',
      title: 'Retry this Post',
      saveButtonText: 'Reschedule Post',
      footerText: '',
      postId: postId,
      payloadProcessor: 'Calendar.retryPayloadProcessor',
      saveApi: 'post.retry',
      saveApiCallBack: 'Calendar.retrySaveCallback',
    };

    app.inputPrompt(options).then(async function ($modal) {
      app.retryModal = $modal;
      const progress = new ProgressBar($modal.find('.container-fluid'));
      progress.start();

      progress.remove();

      const todayDate = moment().format('YYYY-MM-DD');
      let todayDateD = new Date(todayDate);

      const minBuildDate = todayDateD;

      const $input = $modal.find('input[name=scheduleDate]');
      const picker = new easepick.create({
        element: $input[0],
        zIndex: 1200,
        calendars: 1,
        grid: 1,
        format: 'YYYY-MM-DD hh:mm A',
        plugins: [
          "LockPlugin",
          "TimePlugin"
        ],
        LockPlugin: {
          minDate: moment(minBuildDate).format()
        },
        TimePlugin: {
          format: 'hh:mm A',
          hours: {
            step: 1, min: 0, max: 23, default: 12
          },
          minutes: {
            step: 1, min: 0, max: 59, default: 0
          },
          stepMinutes: 1,
          format12: true
        },
        setup: (picker) => {
          picker.on('render', () => {
            if (!picker.getDate()) {
              picker.setDate(new Date());
              picker.setTime('12:00 PM');
            }

            // Apply custom styles to shadow DOM elements
            const shadowRoot = picker.ui.shadowRoot;
            if (shadowRoot) {
              const style = document.createElement('style');
              style.textContent = `
                  .time-plugin-custom-block {
                    width:100%;
                  }
                  
                  .time-plugin-container select {
              
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
                    padding: 0.25rem .5rem 0.25rem 0.75rem;
                    font-size: 0.75rem;
                    font-weight: 400;
                    line-height: 1.5;
                    color: #212529;
                    background-color: #fff;
                    background-clip:padding-box;
                    border:1px solid #ced4da;
                    -webkit-appearance:none;
                    -moz-appearance:none;
                    appearance:none;
                    border-radius:.375rem;
                    transition:border-color .15s ease-in-out,
                    box-shadow .15s ease-in-out;
                    width : calc(33.33% - 6px);
                    background-repeat: no-repeat;
                    background-position: right .75rem center;
                    background-size: 16px 12px;
                  }
              `;
              shadowRoot.appendChild(style);
            }
          });
        },
        css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'],
        inline: true
      });

    })
    ;
  }

  if (action === 'unschedule') {
    app.doButtonAction($this);
    const response = app.apis['post'].unschedule([postId]).then(function () {
      app.doButtonReset($this);
      if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
        const campaignId = app.postActionsContext.split('-')[1];
        PostsList.updateCard(post, post, false, '.tab-content-campaign');
      } else if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('article')) {
        post.post_id = post.id;
        console.log(post);
        PostsList.updateCard(post, post, false, '.articles-container', true);
      } else {
        PostsList.updateCard(post, post);
      }
    });
  }

  if (action === 'approve') {
    app.doButtonAction($this);
    const response = app.apis['calendar'].approvePosts(action, postId).then(function () {
      app.doButtonReset($this);
      if (!app.isEmpty(app.postActionsContext) && app.postActionsContext.includes('campaign')) {
        const campaignId = app.postActionsContext.split('-')[1];
        PostsList.updateCard(post, post, false, '.tab-content-campaign');
      } else {
        PostsList.updateCard(post, post);
      }
    });
  }

  if (action === 'unapprove') {
    const postsSeekingApproval = {};
    postsSeekingApproval[postId] = window.calendarPosts[postId];
    window.postsSeekingApproval = postsSeekingApproval;
    app.inputPrompt({
      type: 'textarea',
      val: '',
      title: 'Why the posts are not approved?',
      saveButtonText: 'Submit Reason',
      inputLabel: 'Reason',
      inputName: 'notes',
      placeHolder: 'Please type details of the changes or issues with the post',
      payloadProcessor: 'aimi_calendar.approvePayloadProcessor',
      saveApi: 'calendar.unApprovePostsSave',
      saveApiCallBack: 'aimi_calendar.approveSaveCallback'
    }).then(function ($modal) {
      app.unApproveModal = $modal;
    });
  }

  if (action === 'resubmit-review') {
    const postsSeekingApproval = {};
    postsSeekingApproval[postId] = window.calendarPosts[postId];
    window.postsSeekingApproval = postsSeekingApproval;
    app.inputPrompt({
      type: 'textarea',
      val: '',
      title: 'Tell collaborator what is fixed',
      saveButtonText: 'Resubmit for Review',
      inputLabel: 'Add notes for collaborator',
      inputName: 'notes',
      placeHolder: 'Please type details of the changes or fixes made',
      payloadProcessor: 'aimi_calendar.reviewPayloadProcessor',
      saveApi: 'calendar.reviewPostsSave',
      saveApiCallBack: 'aimi_calendar.approveSaveCallback'
    }).then(function ($modal) {
      app.unApproveModal = $modal;
    });
  }
}

const postActionEventManager = new EventManager('post-list', '[data-post-action]');
postActionEventManager.addEventListener('click', postActions);

function imageActions(e) {

  e.preventDefault();
  e.stopPropagation();

  const app = PreBuilt;

  const $this = $(this);
  const action = $this.data('image-action');
  let $item = $(e.target).closest('.infinite-item');
  let imageId = $item.data('id');

  if (action === 'maximize') {
    const image = $item.attr('data-org-src');
    const $modal = app.infoModal(`Image #${imageId}`, '', {
      id: 'maximizeModal', 'dialogClass': 'modal-full modal-maximize'
    });
    const $modalBody = $('.modal-body', $modal);

    let template = _.template(app.templates['global__image-maximize']);
    const $template = $(template());
    $template.appendTo($modalBody);

    const $imageContainer = $template.find('[data-current-image]');
    const $infoContainer = $template.find('[data-current-image-info]');

    const imageData = {};
    imageData.pathThumbnail = image;
    imageData.path = image;
    imageData.id = imageId;
    imageData.config = {images: {'addButton': false}};

    const $image = MyUploads.prepareRow(imageData, 'image_library__image-card');
    $imageContainer.append($image);
  }
}

const imageActionEventManager = new EventManager('global-image-events', '[data-image-action]');
imageActionEventManager.addEventListener('click', imageActions);

// Function to scroll an element into view with padding
const scrollToElementWithPadding = function (element, padding = 100) {
  // Find the element
  if (!element) return;

  // Scroll to the element
  element.scrollIntoView({behaviour: 'smooth', block: 'nearest'});

  // const $container = $(element).closest('.tab-scrollable-area').find('.simplebar-content-wrapper');
  // const scrolledY = $container[0].scrollTop;
  // if (scrolledY) {
  //   $container[0].scroll({top: scrolledY - padding});
  // }

  // Wait for the smooth scroll to finish, then adjust the scroll position
  // setTimeout(() => {
  //   const fixedHeaderHeight = document.querySelector('header').offsetHeight;
  //   window.scrollBy(0, -fixedHeaderHeight); // Adjust scroll position by the header's height
  // }, 600); // Adjust the timeout duration to match your scroll duration
}

const observerCampaignView = () => {
  // Function to observe elements
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      if (entry.intersectionRatio > 0) {
        const target = entry.target;
        const id = target.getAttribute('data-target-id');
        const parent = target.getAttribute('data-target');

        $('a', $(parent)).removeClass('active');
        $(`a[href="#${id}"]`, $(parent)).addClass('active');
      }
    });
  }, {
    // Observer options
    rootMargin: '0px',
    threshold: 0.5, // Adjust according to needs
  });

  // Target elements to be observed
  document.querySelectorAll('[data-scroll-observer]').forEach((section) => {
    observer.observe(section);
  });

  $(document).off('click.data-scroll-links').on('click.data-scroll-links', '[data-scroll-links]', function (e) {
    e.preventDefault();
    const target = $(this).attr('href');
    const $target = $(`${target}`);
    scrollToElementWithPadding($target[0], 40)
  });
}